module.exports = __webpack_public_path__ + "img/us_timeline_icon.b9142c47.svg";